import * as React from 'react';

const SvgComponent = _props => {
  const {'aria-label': ariaLabel, role, alt, ...rest} = _props;
  const props = {
    ...rest,
    ...(ariaLabel || alt
      ? {
          role: role || 'img',
          'aria-label': ariaLabel,
          alt
        }
      : {
          'aria-hidden': 'true'
        })
  };
  return (
    <svg
      id="prefix__Calque_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      {...props}
    >
      <style>{'.prefix__st0{fill:currentColor}'}</style>
      <g fill="none" fillRule="evenodd">
        <path
          className="prefix__st0"
          d="M6.3 20.9h7.4c-.1-.3-.1-.7-.1-1 0-3.1 2.3-5.7 5.2-6.2V1c0-.6-.5-1-1-1H6.3v20.9zM4.2 0H1C.5 0 0 .5 0 1v18.8c0 .6.5 1 1 1h3.1V0zM24 18.8h-3.1v-3.1h-2.1v3.1h-3.1v2.1h3.1V24h2.1v-3.1H24v-2.1z"
        />
      </g>
    </svg>
  );
};

export default SvgComponent;
